module.exports = require('./helpers/bundle-url').getBundleURL('5Beya') + "logo.c51670a8.svg";